import {
  faHeart,
  faThumbtack,
  faUserGroup,
} from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Link } from '@sorare/routing';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineL, LabelS } from '@sorare/core/src/atoms/typography';
import { Ellipsis } from '@sorare/core/src/atoms/typography/Ellipsis';
import { ANY_SPORT_MARKET_WATCHLISTS_ID } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

const Root = styled(Vertical)`
  min-width: 280px;
`;

const Thumbnail = styled(Vertical)`
  position: relative;
  width: 100%;
  border-radius: var(--double-unit);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.07) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  border: 1px solid var(--c-nd-150);
  aspect-ratio: 1.255;
`;

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: var(--c-white);
  transform: rotate(45deg);
  position: absolute;
  top: var(--double-unit);
  left: var(--double-unit);
`;

const HeartWrapper = styled(Vertical)`
  padding: var(--double-unit);
  border-radius: 50%;
  background-color: var(--c-nd-50);
`;

const Metas = styled(LabelS)`
  svg {
    margin-right: var(--unit);
  }
`;

export const FavoritesWatchlistItem = ({ count }: { count: number }) => {
  const { sport } = useSportContext();
  return (
    <Root
      as={Link}
      to={generateSportPath(ANY_SPORT_MARKET_WATCHLISTS_ID, {
        sport,
        params: {
          id: 'favorites',
        },
      })}
    >
      <Thumbnail center>
        <StyledFontAwesomeIcon icon={faThumbtack} />
        <HeartWrapper>
          <FontAwesomeIcon icon={faHeart} size="2xl" />
        </HeartWrapper>
      </Thumbnail>
      <HeadlineL>
        <Ellipsis>
          <FormattedMessage defaultMessage="Favorites" />
        </Ellipsis>
      </HeadlineL>
      <Metas color="var(--c-nd-600)">
        <FontAwesomeIcon icon={faUserGroup} color="var(--c-nd-600)" />
        <FormattedMessage
          defaultMessage="{totalPlayersCount, plural, one {# player} other {# players}}"
          values={{ totalPlayersCount: count }}
        />
      </Metas>
    </Root>
  );
};
